// import HTML from "../index.html";
import "./style.scss";
import "./migration.scss";

/********************************* Smooth Scroll *********************************/
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

/********************************* Show More *********************************/
import clickMore from "./scripts/show-more.js";
clickMore();

/********************************* Tour Carousel *********************************/
import toursCarousel from "./scripts/tours-carousel.js";
toursCarousel();

/********************************* Thombstone *********************************/
import tombstonesCarousel from "./scripts/tombstones-carousel.js";
// Initialize tombstonesCarousel() for each instance.
document.querySelectorAll('.slider-with-external-buttons')
        .forEach(tombstonesCarousel);


/********************************* Modal *********************************/
import MicroModal from 'micromodal';  // es6 module
import modalStart from "./scripts/modal";
modalStart();

/********************************* Lazy Load Trustpilot boxes *********************************/
import lazyloadTrustpilot from "./scripts/lazyload-trustpilot";
lazyloadTrustpilot ()

/********************************* Header SearchBar ********************************/

import headerSearch from "./scripts/header-search";
headerSearch();
/********************************* Header Submenu *********************************/

import headerSubmenu from "./scripts/header-submenu";
headerSubmenu();

/********************************* Lazy Loading Images *********************************/

import lazyloadImages from "./scripts/lazyload-images";
lazyloadImages ()

/********************************* Images on hover *********************************/

import swapImages from "./scripts/swap-images";
swapImages ()

/********************************* Images on hover *********************************/

import contactus from "./scripts/contact-us";
contactus ()

/********************************* scroll more *********************************/

import scrollmore from "./scripts/scrollmore";
scrollmore ()

/********************************* Collapsable Items *********************************/

import collapsable from "./scripts/collapsable";
collapsable ()

/********************************* Itineraries Page ********************************/

import itineraries from "./scripts/itineraries";
itineraries ()

/********************************* All Lodges Page ********************************/

import allLodges from "./scripts/all-lodges";
allLodges ()

/********************************* Newsletter Signup ********************************/

import newsletterSignup from "./scripts/newsletter-signup";
newsletterSignup ()

/********************************* Page FadeIn ********************************/

import fadeInPage from "./scripts/fadein-page.js";
fadeInPage ()